import _module from 'module.js'

export default class UnifiedAdminLocationsService {
  constructor (globalState, featuresService, userService) {
    'ngInject'
    this.globalState = globalState
    this.featuresService = featuresService
    this.userService = userService
  }

  isLocationsAvailable () {
    return this.userService.isUserSuperAdmin(this.globalState.selectedPbx) ||
      this.userService.hasPbxAdminPermission(this.globalState.selectedPbx) ||
      this.globalState.isPartnerPbxAdmin ||
      this.isPartnerPbxAdmin.isPartnerAdmin ||
      this.globalState.isPlatformAdmin ||
      this.globalState.isPlatform;
  }
}

_module.service(
  'unifiedAdminLocationsService',
  UnifiedAdminLocationsService
)
